"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCustomDateTimeFormat = exports.CreateCustomDateTimeFormatOption = exports.CreateCustomDateTimeFormatOptionActionTypes = exports.loadMonthFormatOptions = exports.FetchMonthFormatOptions = exports.FetchMonthFormatOptionsActionTypes = exports.loadDateTimeFormatOptions = exports.FetchDateTimeFormatOptions = exports.FetchDateTimeFormatOptionsActionTypes = exports.LanguageActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _constants = require("./constants");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _I18n = _interopRequireDefault(require("I18n"));

var LanguageActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_DATETIME_FORMAT_OPTIONS: null,
  FETCH_DATETIME_FORMAT_OPTIONS: null,
  LOAD_MONTH_FORMAT_OPTIONS: null,
  FETCH_MONTH_FORMAT_OPTIONS: null,
  CREATE_CUSTOM_DATE_TIME_FORMAT_OPTION: null,
  ADD_CUSTOM_DATE_TIME_FORMAT_OPTION: null,
  ADD_CUSTOM_MONTH_FORMAT_OPTION: null
}, _constants.BLOG_LANGUAGE);
exports.LanguageActionTypes = LanguageActionTypes;
var FetchDateTimeFormatOptionsActionTypes = (0, _actions.createRequestTypes)(LanguageActionTypes.FETCH_DATETIME_FORMAT_OPTIONS);
exports.FetchDateTimeFormatOptionsActionTypes = FetchDateTimeFormatOptionsActionTypes;
var FetchDateTimeFormatOptions = (0, _actions.createRequestActions)(FetchDateTimeFormatOptionsActionTypes, {
  keys: ['language', 'selected']
});
exports.FetchDateTimeFormatOptions = FetchDateTimeFormatOptions;
var loadDateTimeFormatOptions = (0, _fluxActions.createAction)(LanguageActionTypes.LOAD_DATETIME_FORMAT_OPTIONS, (0, _actions.mapPayloadTo)('language', 'selected'));
exports.loadDateTimeFormatOptions = loadDateTimeFormatOptions;
var FetchMonthFormatOptionsActionTypes = (0, _actions.createRequestTypes)(LanguageActionTypes.FETCH_MONTH_FORMAT_OPTIONS);
exports.FetchMonthFormatOptionsActionTypes = FetchMonthFormatOptionsActionTypes;
var FetchMonthFormatOptions = (0, _actions.createRequestActions)(FetchMonthFormatOptionsActionTypes, {
  keys: ['language', 'selected']
});
exports.FetchMonthFormatOptions = FetchMonthFormatOptions;
var loadMonthFormatOptions = (0, _fluxActions.createAction)(LanguageActionTypes.LOAD_MONTH_FORMAT_OPTIONS, (0, _actions.mapPayloadTo)('language', 'selected'));
exports.loadMonthFormatOptions = loadMonthFormatOptions;
var CreateCustomDateTimeFormatOptionActionTypes = (0, _actions.createRequestTypes)(LanguageActionTypes.CREATE_CUSTOM_DATE_TIME_FORMAT_OPTION);
exports.CreateCustomDateTimeFormatOptionActionTypes = CreateCustomDateTimeFormatOptionActionTypes;
var CreateCustomDateTimeFormatOption = (0, _actions.createRequestActions)(CreateCustomDateTimeFormatOptionActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateCustomDateTimeFormatOptionActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.blog.notifications.customDateTimeFormatCreateSuccess')));
  },
  failureMetaCreator: function failureMetaCreator(error) {
    var requestStatusMeta = (0, _actions.createRequestStatusMeta)(CreateCustomDateTimeFormatOptionActionTypes.base, _RequestStatusTypes.default.FAILED);

    if (error && error.responseJSON && (error.responseJSON.errorType === 'INVALID_DATE_FORMAT_FOR_DATE' || error.responseJSON.errorType === 'INVALID_DATE_FORMAT_STRING')) {
      return (0, _extends2.default)({}, requestStatusMeta, (0, _actions.createDangerNotificationMeta)(error.responseJSON.message));
    }

    return (0, _extends2.default)({}, requestStatusMeta, (0, _actions.createDangerNotificationMeta)(_I18n.default.text('marketing.blog.notifications.customDateTimeFormatCreateFailureGeneric')));
  }
});
exports.CreateCustomDateTimeFormatOption = CreateCustomDateTimeFormatOption;
var createCustomDateTimeFormat = (0, _fluxActions.createAction)(LanguageActionTypes.CREATE_CUSTOM_DATE_TIME_FORMAT_OPTION, (0, _actions.mapPayloadTo)('data'));
exports.createCustomDateTimeFormat = createCustomDateTimeFormat;